import { render, staticRenderFns } from "./OccurrencesTableView.vue?vue&type=template&id=93155654&scoped=true&"
import script from "./OccurrencesTableView.vue?vue&type=script&lang=js&"
export * from "./OccurrencesTableView.vue?vue&type=script&lang=js&"
import style0 from "./OccurrencesTableView.vue?vue&type=style&index=0&id=93155654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93155654",
  null
  
)

export default component.exports